import { inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of } from 'rxjs';

import { switchMapBy } from '@core/common-legacy';

import { IntercomArticlesActions } from './intercom-articles.store';
import { IntercomHttpService } from '../services/intercom-http.service';

export const fetchIntercomArticlesEffect = createEffect(
  (actions = inject(Actions), httpService = inject(IntercomHttpService)) =>
    actions.pipe(
      ofType(IntercomArticlesActions.fetchPaginatedCollection),
      map(action => action.payload),
      switchMapBy('scope', ({ scope, params }) =>
        httpService.fetchArticles(params.limit, params.page).pipe(
          map(articles =>
            IntercomArticlesActions.fetchPaginatedCollectionSuccess({
              payload: { scope, data: { rows: articles, meta: { ...params, totalCount: 0 } } },
            }),
          ),
          catchError(error =>
            of(
              IntercomArticlesActions.fetchPaginatedCollectionFailed({ payload: { error, scope } }),
            ),
          ),
        ),
      ),
    ),
  { functional: true },
);
